module.exports = __webpack_public_path__ + "static/media/logo.4a5020e9.png";